const prodFacebookPixelId = '934768840401987';
const nonProdFacebookPixelId = '123456789123456';

const voiceflowVersionIdNonProd = 'development';

function deriveFeatureKeys(meta) {
    if (meta.type === 'prod') {
        return {
            appleClientId: 'com.universaltennis.web',
            brazeApiKey: process.env.BRAZE_API_KEY || '',
            pixelId: prodFacebookPixelId,
            segmentKey: process.env.SEGMENT_KEY || '',
            statsigKey: process.env.STATSIG_CLIENT_KEY || '',
            stripeClientId: process.env.STRIPE_CLIENT_ID || '',
            stripeKey: process.env.STRIPE_PUBLISHABLE_KEY || '',
            voiceflowProjectId: process.env.VOICEFLOW_PROJECT_ID || '',
            voiceflowVersionId: undefined,
        };
    }

    if (meta.type === 'local') {
        return {
            appleClientId: 'com.universaltennis.web-test8',
            brazeApiKey: process.env.BRAZE_API_KEY || '',
            pixelId: nonProdFacebookPixelId,
            segmentKey: process.env.SEGMENT_KEY || '',
            statsigKey: process.env.STATSIG_CLIENT_KEY || '',
            stripeClientId: process.env.STRIPE_CLIENT_ID || '',
            stripeKey: process.env.STRIPE_PUBLISHABLE_KEY || '',
            voiceflowProjectId: process.env.VOICEFLOW_PROJECT_ID || '',
            voiceflowVersionId: voiceflowVersionIdNonProd,
        };
    }

    return {
        appleClientId: 'com.universaltennis.web-test8',
        brazeApiKey: process.env.BRAZE_API_KEY || '',
        pixelId: nonProdFacebookPixelId,
        segmentKey: process.env.SEGMENT_KEY || '',
        statsigKey: process.env.STATSIG_CLIENT_KEY || '',
        stripeClientId: process.env.STRIPE_CLIENT_ID || '',
        stripeKey: process.env.STRIPE_PUBLISHABLE_KEY || '',
        voiceflowProjectId: process.env.VOICEFLOW_PROJECT_ID || '',
        voiceflowVersionId: voiceflowVersionIdNonProd,
    };
}

function deriveFlags(meta) {
    if (meta.type === 'local') {
        return {
            enableAnalytics: true,
            brazeEnableLogging: true,
            collegeCornerAd: true,
            alwaysUseProxy: true,
            isLocalhost: true,
            devtoolConfig: false,
        };
    }

    if (meta.type === 'prod') {
        return {
            enableAnalytics: true,
            brazeEnableLogging: false,
            collegeCornerAd: true,
            alwaysUseProxy: process.env.ALWAYS_USE_PROXY || false,
            isLocalhost: false,
            devtoolConfig: meta.debug ? 'source-map' : false,
        };
    }

    // Any eval-* devtool wraps each module in an eval() string that Terser cannot
    // minify, inflating main.js from ~10MB to ~65MB. Keep source maps as separate files.
    return {
        enableAnalytics: true,
        brazeEnableLogging: true,
        collegeCornerAd: true,
        alwaysUseProxy: false,
        isLocalhost: false,
        devtoolConfig: 'source-map',
    };
}

module.exports = {
    deriveFeatureKeys,
    deriveFlags,
};
